import { TFunction } from '@lyearn/i18n';
import { ImageOutline, VideoOutline } from '@lyearn/icons';

import { AddQuestionMediaType } from './types';

export const getQuestionMediaItems = (t: TFunction) => [
  {
    id: AddQuestionMediaType.Image,
    label: t('QuizCreator:QuestionsSettings.Image'),
    StartIcon: ImageOutline,
  },
  {
    id: AddQuestionMediaType.Video,
    label: t('QuizCreator:QuestionsSettings.Video'),
    StartIcon: VideoOutline,
  },
];
